<template>
  <div class="header-container" :class="isScroll?'bg-color':''">
    <div class="header">
      <div class="wap-btns" @click.stop="isNavShow =! isNavShow">
        <a-icon type="align-right" :rotate="180" />
      </div>
      <div class="leftbox">
        <a href="/">
          <img :src="siteInfo.logo" height="100%" />
        </a>
      </div>
      <ul class="navbox" v-show="isNavShow">
        <li v-for="(item,index) in navList" :key="index">
          <span @click="pointTo(item.location)">{{item.text}}</span>
        </li>
        <li><span :class="navIndex == 1?'active':''" @click="goto('/news')">幫助中心</span> </li>
      </ul>
      <div class="rightuserbox" v-if="isLogin">
        <div class="release-btn" v-if="isShowPublish">
          <a-button type="primary" @click="handlePublishClick">{{$t(`moduleTitles.pcpublish`)}}</a-button>
        </div>
        <a-popover placement="bottomRight" :visible="userShow" @visibleChange="handleuserChange">
          <template slot="content">
            <ul class="user-ul">
              <li @click="userGo()">
              <span v-if="userInfo.type===1">
                <a-icon class="ant-icon" type="user" />{{$t('common.adminBackground')}}
              </span>
              <span v-if="userInfo.type===2">
                <a-icon class="ant-icon" type="user" />{{$t('common.agentBackground')}}
              </span>
              <span v-if="userInfo.type===3">
                <a-icon class="ant-icon" type="user" />{{$t('common.memberBackground')}}
              </span>
              <span v-if=" userInfo.type===4">
                <a-icon class="ant-icon" type="user" />{{$t('common.employeeBackground')}}
              </span>
              </li>
              <li @click="logOut">
                <a-icon class="ant-icon" type="poweroff" />{{$t('common.logout')}}
              </li>
            </ul>
          </template>
          <a-avatar :size="38" v-if="userInfo!=undefined" :src="userInfo.avatar ? userInfo.avatar : defaultImg" />
        </a-popover>
      </div>
      <div class="rightbox" v-else>
        <a-button
          type="link"
          class="register-btn"
          @click="showRegister"
          v-if="+siteInfo.close_reg === 0"
        >{{$t('login.freeRegister')}}</a-button>
        <a-button type="primary" class="login-btn" @click="showLogin">{{$t('login.login')}}</a-button>
      </div>
    </div>

    <!-- 登錄框 -->
    <a-modal
      :title="$t('login.memberLogin')"
      :visible="modellogin"
      :destroyOnClose="true"
      :footer="null"
      width="360px"
      @cancel="cancelLogin"
    >
      <login></login>
      <span  v-if="+siteInfo.close_reg === 0">
        {{$t('login.noAccount')}}？
        <a @click="showRegister">{{$t('login.register')}}</a>
      </span>

      <a href="javascript:void(0);" style="float:right;" @click="retrievePassword">{{$t('login.findPassword')}}</a>
      <div style="clear:both"></div>
    </a-modal>
    <!-- 註冊框 -->
    <a-modal
      :title="$t('login.userRegister')"
      :destroyOnClose="true"
      :footer="null"
      width="360px"
      :visible="modelregister"
      @cancel="cancelLogin"
    >
      <register></register>{{$t('login.hasAccount')}}？
      <a @click="showLogin">{{$t('login.toLogin')}}</a>
    </a-modal>
    <!-- 找回密碼 -->
    <a-modal
      :title="$t('login.findPassword')"
      :destroyOnClose="true"
      :footer="null"
      width="360px"
      :visible="modelfindpwd"
      @cancel="modelfindpwd=false"
    >
      <findpwd @login="showLogin"></findpwd>{{$t('login.hasAccount')}}？
      <a @click="showLogin">{{$t('login.toLogin')}}</a>
    </a-modal>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import login from "./login";
import register from "./register";
import findpwd from "./findpwd";
export default {
  name: "headers",
  components: { login, register, findpwd },
  props: {
    navIndex: {
      type: Number,
      default: 0,
    },
    backgroundBg: {
      type:Boolean,
      default: true
    },
    isHomePage:{
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      modellogin: false,
      modelregister: false,
      modelfindpwd: false,
      navList:[
        {text:'首頁',location: 'pano'},
        {text:'智慧工地',location: 'content1'},
        {text:'小程序',location: 'content2'},
        {text:'技術支持',location: 'content3'},
        {text:'聯繫我們',location: 'content4'}
      ],
      defaultImg: '/ssr/static/images/default_avatar.jpg',
      userShow: false,
      isLogin: false,
      isNavShow: true,
      offsetWidth: "",
      isScroll:false
    };
  },
  computed: {
    ...mapState({
      siteInfo: (state) => state.siteConfig.siteInfo,
      userInfo: (state) => state.user.userInfo,
    }),
    isShowPublish(){
      return this.userInfo && this.userInfo.type==3;
    }
  },
  created() {
    if (this.userInfo != undefined) {
      this.isLogin = true;
    }
    //創建時執行跳轉錨點位置
    this.$nextTick(() => {
      this.getlocal()
    })
  },
  mounted() {
    this.offsetWidth = document.body.offsetWidth;
    window.onresize = () => {
      return (() => {
        this.offsetWidth = document.body.offsetWidth;
      })();
    };

    let self = this;
    document.addEventListener("click", function (e) {
      if (self.offsetWidth < 768) {
        self.isNavShow = false;
      }
    });

    this.$nextTick(()=>{
      // 判斷頭部是否初始化就有背景色
      if(!this.backgroundBg){
        this.isScroll = false
        window.addEventListener('scroll',this.handleScroll)
      }else{
        this.isScroll = true
      }
    })

  },
  methods: {
    //從我本地找到id
    getlocal(){
      //找到錨點id
      let selectId = localStorage.getItem("toId");
      let toElement = document.getElementById(selectId);
      //如果對應id存在，就跳轉
      if(selectId!=null && toElement!=null){
        toElement.scrollIntoView(true)
      }
      //銷毀localStorage裡面的toId
      setTimeout(()=>{
        localStorage.removeItem("toId")
      },1000*20)
    },
    //定位方法
    pointTo(location){
      if (this.isHomePage){
        document.querySelector('#'+location).scrollIntoView(true);
      }
      else{
        let selectId = location;
        localStorage.setItem("toId",selectId);
        this.$router.push({path: '/'});
      }
    },
    //滾動頭部背景顏色顯示隱藏方法
    handleScroll(){
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop // 滾動條偏移量
      this.isScroll = scrollTop > 100 ? true : false; // 如果滾動到頂部了，this.isScroll就為true
    },
    //單個跳轉頁面方法
    goto(url){
      this.$router.push({ path: url });
    },
    showLogin() {
      this.cancelLogin();
      this.modellogin = true;
    },
    showRegister() {
      this.cancelLogin();
      this.modelregister = true;
    },
    retrievePassword() {
      this.modellogin = false;
      this.modelfindpwd = true;
    },
    cancelLogin() {
      this.modellogin = false;
      this.modelregister = false;
      this.modelfindpwd = false;
    },
    handleuserChange(visible) {
      this.userShow = visible;
    },
    userGo() {
      this.userShow = false;
      if (this.$isMobile()) {
        this.$router.push({ path: "/mobile/member/mine" });
      } else {
        let userType = this.userInfo.type;
        if (userType == 1) {
           this.$router.push({ path: "/admin/home" });
        } else if (userType == 2) {
           this.$router.push({ path: "/agent/home" });
        } else if (userType == 3){
          this.$router.push({ path: "/member/home" });
        } else {
          this.$router.push({ path: "/employee/home" });
        }
      }
    },
    handlePublishClick() {
      let name = this.$isMobile() ? "mbpublish" : "pcpublish";
      this.$router.push({ name });
    },
    logOut() {
      this.$store.dispatch("logout").then((res) => {
        this.$message.success({
          content: this.$t('message.logoutMsg1'),
        });
        this.userShow = false;
        setTimeout(() => {
          this.isLogin = false;
        }, 500);
      });
    },
  },

  watch: {
    offsetWidth(val) {
      if (val > 768) {
        this.isNavShow = true;
      } else {
        this.isNavShow = false;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.header-avatar {
  position: absolute;
  top: 15px;
  left: 10px;
  border-radius: 50px;
  width: 38px;
  height: 38px;
}
</style>
<style lang="less">
  .p-Top-58{
    padding-top: 58px;
  }
ul,
li {
  margin: 0;
  padding: 0;
  list-style: none;
}

.user-ul {
  width: 100px;
  li {
    display: inline-block;
    width: 100%;
    height: 30px;
    line-height: 30px;
    color: #666666;
    text-align: center;
    cursor: pointer;
    padding: 0 10px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    overflow: hidden;
    &:hover {
      color: #0a67fb;
    }
    .ant-icon {
      margin-right: 4px;
    }
  }
}
.header-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  height: 58px;
  /*background-color: #333;*/
  color: #333;
  &.bg-color{
    background-color: #333;
  }
  .header {
    max-width: 1200px;
    margin: 0 auto;
    height: 58px;
    .wap-btns {
      display: none;
    }
    .leftbox {
      float: left;
      height: 58px;
      padding: 12px 5px;
    }

    .rightbox {
      float: right;
      height: 58px;
      padding: 16px 12px;

      .ant-btn {
        height: 26px;
        padding: 0 10px;
        border-radius: 2px;
      }
      .register-btn {
        color: rgba(255, 255, 255, 0.7);
        margin-right: 10px;
        &:hover {
          color: rgba(255, 255, 255, 1);
        }
      }
    }
    .rightuserbox {
      float: right;
      height: 58px;
      padding: 8px 5px;
      display: flex;
      .release-btn{
        margin: 3px 20px 0 0;
      }
    }

    ul.navbox {
      float: left;
      margin-left: 50px;

      li {
        float: left;
        padding: 18px 20px;

        a , span{
          color: rgba(255, 255, 255, 0.8);
          display: inline-block;
          cursor: pointer;
        }

        a.active,span.active {
          color: rgba(255, 255, 255, 1);
          border-bottom: 1px solid #fff;
        }
      }
    }
  }
}
@media (max-width: 768px) {
  .header-container {
    .header {
      position: relative;
      display: flex;
      justify-content: space-between;
      .wap-btns {
        display: flex;
        width: 58px;
        height: 58px;
        color: #ffffff;
        justify-content: center;
        align-items: center;
        font-size: 24px;
      }
      .leftbox {
        padding: 12px 5px;
      }

      .rightbox {
        .register-btn {
          display: none;
        }
      }
      .rightuserbox {
        margin-right: 10px;
        .release-btn{
          display: none;
        }
      }

      ul.navbox {
        float: none;
        position: absolute;
        top: 58px;
        left: 0;
        right: 0;
        margin-left: 0;
        z-index: 11;
        background-color: #333;
        li {
          width: 100%;
          text-align: center;
          padding: 0 30px;
          &:last-child {
            a ,span{
              border-bottom: 0;
            }
          }
          a ,span{
            color: rgba(255, 255, 255, 0.6);
            display: block;
            width: 100%;
            padding: 18px 0;
            border-bottom: 1px solid rgba(255, 255, 255, 0.05);
          }

          a.active {
            color: #0a67fb;
            border-bottom: 1px solid rgba(255, 255, 255, 0.05);
          }
        }
      }
    }
  }
}
</style>
